import "/src/firebaseModel.js";
import { syncUser } from "./firebaseModel";
import { createRoot } from "react-dom/client";
import Router from "./Router";
import ArtModel from "./ArtModel";
import { observable } from "mobx";

const reactiveModel = observable(ArtModel);

reactiveModel.initialize();
syncUser(reactiveModel);

createRoot(document.getElementById("root")).render(<Router model={reactiveModel} />);